<template>
  <div class="couponPackage">
    <el-tabs v-model="activeName" @tab-click="handleChangeTab">
      <el-tab-pane :label="'未使用('+notUsedData.length+')'" name="notUsed">
        <div class="couponList">
          <div class="clearfix sub-main" v-if="notUsedData.length > 0">
            <div class="couponItem active" v-for="(item, index) of notUsedData" :key="index">
              <div class="couponItemTop">
                <img src="../../../assets/images/indexLogo.png" alt="">
                <span><i>￥</i>{{item.couponPrice}}</span>
                <span>优惠券类型：{{item.couponTitle}}</span>
                <span>满{{item.useMinPrice}}元可用</span>
                <span>有效期：{{item.createTime}}-{{item.endTime}}</span>
                <div class="couponType">平台卷</div>
              </div>
              <div class="couponItemBot" @click="useCoupon(item.cid)">
                立即使用
              </div>
            </div>
          </div>
          <div class="noCoupon" v-else>
              <img src="../../../../static/image/noorder@2x.png" alt="">
              <p class="fs20 font-color-999">你还没有未使用的卷包哦～</p>
          </div>
<!--          <el-pagination-->
<!--            background-->
<!--            layout="prev, pager, next, jumper"-->
<!--            :total="1000">-->
<!--          </el-pagination>-->
        </div>
      </el-tab-pane>
      <el-tab-pane :label="'已使用('+usedData.length+')'" name="used">
        <div class="couponList">
          <div class="clearfix sub-main" v-if="usedData.length > 0">
            <div class="couponItem" v-for="(item, index) of usedData" :key="index">
              <div class="couponItemTop">
                <img src="../../../assets/images/indexLogo.png" alt="">
                <span><i>￥</i>{{item.couponPrice}}</span>
                <span>优惠券类型：{{item.couponTitle}}</span>
                <span>满{{item.useMinPrice}}元可用</span>
                <span>有效期：{{item.createTime}}-{{item.endTime}}</span>
                <div class="couponType">平台卷</div>
              </div>
              <div class="couponItemBot">
                已使用
              </div>
            </div>
          </div>
          <div class="noCoupon" v-else>
              <img src="../../../../static/image/noorder@2x.png" alt="">
              <p class="fs20 font-color-999">你还没有已使用的卷包哦～</p>
          </div>
          <!--          <el-pagination-->
          <!--            background-->
          <!--            layout="prev, pager, next, jumper"-->
          <!--            :total="1000">-->
          <!--          </el-pagination>-->
        </div>
      </el-tab-pane>
      <el-tab-pane :label="'已失效('+invalid.length+')'" name="invalid">
        <div class="couponList">
          <div class="clearfix sub-main" v-if="invalid.length > 0">
            <div class="couponItem" v-for="(item, index) of invalid" :key="index">
              <div class="couponItemTop">
                <img src="../../../assets/images/indexLogo.png" alt="">
                <span><i>￥</i>{{item.couponPrice}}</span>
                <span>优惠券类型：{{item.couponTitle}}</span>
                <span>满{{item.useMinPrice}}元可用</span>
                <span>有效期：{{item.createTime}}-{{item.endTime}}</span>
                <div class="couponType">平台卷</div>
              </div>
              <div class="couponItemBot">
                已失效
              </div>
            </div>
          </div>
          <div class="noCoupon" v-else>
              <img src="../../../../static/image/noorder@2x.png" alt="">
              <p class="fs20 font-color-999">你还没有已失效的卷包哦～</p>
          </div>
          <!--          <el-pagination-->
          <!--            background-->
          <!--            layout="prev, pager, next, jumper"-->
          <!--            :total="1000">-->
          <!--          </el-pagination>-->
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import api from '@/api'
import { listSearchMixin } from '@/config/mixin'
export default {
  name: 'couponPackage',
  mixins: [listSearchMixin],
  data () {
    return {
      activeName: 'notUsed',
      notUsedData: [],
      usedData: [],
      invalid: []
    }
  },
  mounted () {
    this.getCouponList(0)
    this.getCouponList(1)
    this.getCouponList(2)
   },
  methods: {
    getCouponList (state) {
      const rLoading = this.openLoading()
      let self = this
      let params = {
        url: api.getCouponList,
        method: 'GET',
        payload: {
          type: state,
        }
      }
      self.sendReq(params, (res) => {
        console.log(res);
        if (res.success) {
          if (state === 0) {
            self.notUsedData = res.data
          } else if (state === 1) {
            self.usedData = res.data
          } else if (state === 2) {
            self.invalid = res.data
          }
          rLoading.close()
        }
      })
    },
    handleChangeTab (tab, event) {
      // console.log(tab, event)
    },
    // 使用优惠券
    useCoupon (id) {
      this.$router.push({name: 'couponProList', params: {activityId: id}})
    }
  }
}
</script>

<style lang="scss" scoped>
.couponPackage {
  border: 1px solid #E5E5E5;
  min-height: 500px;
  >>> .el-tabs__nav-scroll {
    padding-left: 30px;
    .el-tabs__nav {
      height: 60px;
      line-height: 60px;
    }
  }
  >>> .el-tabs__content {
    padding:0 30px;
  }
  .couponList {
    margin-bottom: 30px;
    padding: 20px;
    .couponItem {
      width: 245px;
      border: 1px solid #EEEEEE;
      border-radius: 18px;
      overflow: hidden;
      margin:0 100px 50px 0;
      float: left;
      &:nth-child(3n) {
        margin-right: 0;
      }
      .couponItemTop {
        background: #d7d7d7;
        color: #ffffff;
        padding: 20px;
        box-sizing: border-box;
        position: relative;
        img {
          opacity: 0.2;
          position: absolute;
          top: 40%;
        }
        .couponType {
          position: absolute;
          top: 1px;
          right: -33px;
          width: 100px;
          transform: rotate(45deg);
          background: #FFFFFF;
          color: #999999;
          text-align: center;
          height: 40px;
          line-height: 50px;
        }
        span {
          font-size: 12px;
          display: block;
          margin-bottom: 18px;
          cursor: pointer;
          i {
            margin-right: 5px;
            font-style: normal;
            font-size: 16px;
          }
        }
        span:nth-child(2) {
          font-size: 28px;
        }
        span:nth-child(4) {
          margin-bottom: 0;
        }
      }
      .couponItemBot {
        height: 40px;
        line-height: 40px;
        color: #999999;
        position: relative;
        text-align: center;
        background: #FFFFFF;
        cursor: pointer;
      }
    }
    .active {
      .couponItemTop {
        background: #fd5b5b;
        color: #ffffff;
        .couponType {
          background: #FFFFFF;
          color: #fd5b5b;
        }
      }
      .couponItemBot {
        background: #f3f3f3;
        color: #333333;
      }
    }
  }
  .noCoupon{
    text-align: center;
  }
}
.sub-main{
  min-height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/couponPackage/couponPackage.vue